export const ARTIFACT_REGRESSION_DISPATCHER =
  'common_dispatcher_artifact_regression';
export const AXIOM_UI_DISPATCHER = 'common_dispatcher_axiom_ui_tests';
export const CASE_METRICS = 'run_case_metrics';
export const CASE_METRICS_DISPATCHER = 'common_dispatcher_case_metrics';
export const DIFF_TOOL_REGRESSION_DISPATCHER =
  'common_dispatcher_difftool_regression';
export const PERFORMANCE = 'run_performance_test';
export const PERFORMANCE_DISPATCHER =
  'common_dispatcher_performance_tests';
export const CASE_AMENDING = 'case_amending';
export const CASE_AMENDING_DISPATCHER =
  'common_dispatcher_case_amending';
export const CASE_AMENDING_KPP = 'case_amending_kpp';
export const CASE_AMENDING_KPP_DISPATCHER =
  'common_dispatcher_case_amending_kpp';
export const CASE_MERGING =
  'case_merging';
export const CASE_MERGING_DISPATCHER =
  'common_dispatcher_case_merging';
export const EXPORT = 'run_export_tests';
export const JOBBENCHMARK = 'run_job_benchmark';
export const EXPORT_DISPATCHER =
  'common_dispatcher_export_tests';
export const ENGINE_METRICS_DISPATCHER = 'common_dispatcher_engine_regression';
export const JOB_BENCHMARK_DISPATCHER = 'common_dispatcher_job_benchmark';
export const UI_DISPATCHER = 'common_dispatcher_ui_tests';
export const INSTALLER_DISPATCHER = 'common_dispatcher_ui_installer_tests';
export const TEST_STUDIO_DISPATCHER = 'common_dispatcher_teststudio';
export const REMOTE_AQUIRE_REGRESSION_DISPATCHER =
  'common_dispatcher_remote_acquire_e2e_cli';


// WEBPACK FOOTER //
// src/helpers/jobNames.js